import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { NO_AUTH_NEEDED } from '@/types';

const VisualOffersLandingPage = () => import('@/visual-offers/pages/visual-offers-landing.vue');
const VisualOffersBuilderPage = () => import('@/visual-offers/pages/visual-offers-builder.vue');
const VisualOffersPreviewPage = () => import('@/visual-offers/pages/visual-offers-preview.vue');

const beforeEnterCallback: NavigationGuard = (to, from, next) => {
  const authStore = useAuthStore();
  const isAllowed = authStore.profile.app_access.nav.visual_offers;

  if (isAllowed) {
    return next();
  } else {
    next({ name: 'home' });
  }
};

export const visualOffersRoutes = [
  {
    path: '/visual-offers',
    name: 'visual-offers-landing',
    component: VisualOffersLandingPage,
    beforeEnter: beforeEnterCallback,
  },
  {
    path: '/visual-offers-builder/:id',
    name: 'visual-offers-builder',
    props: true,
    component: VisualOffersBuilderPage,
    beforeEnter: beforeEnterCallback,
  },
  {
    path: '/visual-offers/:id',
    name: 'visual-offers',
    component: VisualOffersPreviewPage,
    meta: {
      [NO_AUTH_NEEDED]: true,
      layout: 'layout-visual-offer-empty',
    },
  },
  {
    path: '/visual-offers/preview/:id',
    name: 'visual-offers-preview',
    component: VisualOffersPreviewPage,
    meta: {
      layout: 'layout-visual-offer-empty',
    },
    beforeEnter: beforeEnterCallback,
  },
];
